<template>
  <div class="announcement-wrap pb50">
    <el-form ref="form" size="small" :model="form" label-width="120px" class="publish-form">
      <div class="common-form">发布公告</div>
      <el-form-item label="标题" required>
        <el-input v-model="form.title" class="max-w640" placeholder="公告标题" maxlength="120" show-word-limit />
      </el-form-item>
      <el-form-item label="正文" required>
        <Uediter
          v-if="ueShow"
          :config="ueConfig"
          :text="form.content"
          v-model="form.content"
          @contentChange="onContentChange"
        />
        <div class="form-tip">富文本 HTML，APP 详情页使用 rich-text / web-view 渲染 content_html</div>
      </el-form-item>
      <el-form-item label="推送范围">
        <el-radio-group v-model="form.push_scope">
          <el-radio label="none">不推送（仅发公告）</el-radio>
          <el-radio label="all">全部用户</el-radio>
          <el-radio label="user">指定用户</el-radio>
        </el-radio-group>
        <div class="form-tip">选择推送时会写站内信并 APP 推送；通知栏仅展示「推送摘要」，详情见公告页</div>
      </el-form-item>
      <el-form-item label="首页动态">
        <el-switch v-model="form.is_home" :active-value="1" :inactive-value="0" />
        <span class="form-tip inline-tip">开启后进入小程序首页动态轮播</span>
      </el-form-item>
      <el-form-item label="首页排序">
        <el-input-number v-model="form.sort" :min="0" :max="9999" />
        <span class="form-tip inline-tip">数值越小越靠前，相同值按发布时间倒序</span>
      </el-form-item>
      <el-form-item v-if="editingId" label="展示状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">已发布</el-radio>
          <el-radio :label="2">已下线</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.push_scope !== 'none'" label="推送摘要" required>
        <el-input
          v-model="form.push_summary"
          class="max-w640"
          type="textarea"
          :rows="2"
          maxlength="50"
          show-word-limit
          placeholder="通知栏短文案，建议 50 字内；留空则从正文自动截取"
        />
      </el-form-item>
      <el-form-item v-if="form.push_scope === 'user'" label="用户 ID" required>
        <el-input v-model="form.target_user_id" class="max-w640" placeholder="目标用户 user_id" />
      </el-form-item>
      <el-form-item>
        <el-button v-if="!editingId" type="primary" :loading="publishing" @click="submitPublish" v-auth="'/setting/umengpush/announcement/publish'">发布公告</el-button>
        <template v-else>
          <el-button type="primary" :loading="publishing" @click="submitEdit">保存修改</el-button>
          <el-button :disabled="publishing" @click="cancelEdit">取消编辑</el-button>
        </template>
      </el-form-item>
    </el-form>

    <div class="common-form">历史公告</div>
    <el-table size="small" :data="tableData" border v-loading="loading">
      <el-table-column prop="announcement_id" label="ID" width="72" />
      <el-table-column prop="title" label="标题" min-width="140" show-overflow-tooltip />
      <el-table-column prop="push_summary" label="推送摘要" min-width="120" show-overflow-tooltip />
      <el-table-column label="推送范围" width="100">
        <template slot-scope="scope">{{ pushScopeText(scope.row.push_scope) }}</template>
      </el-table-column>
      <el-table-column prop="target_user_id" label="目标用户" width="90">
        <template slot-scope="scope">
          {{ scope.row.push_scope === 'user' ? scope.row.target_user_id : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="push_message_count" label="触达人数" width="90" />
      <el-table-column prop="create_time" label="发布时间" width="160" />
      <el-table-column prop="sort" label="排序" width="70" />
      <el-table-column label="首页" width="70">
        <template slot-scope="scope">
          <el-tag size="small" :type="Number(scope.row.is_home) === 1 ? 'success' : 'info'">{{ Number(scope.row.is_home) === 1 ? '展示' : '隐藏' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">{{ statusText(scope.row.status) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editRow(scope.row)" v-auth="'/setting/umengpush/announcement/edit'">编辑</el-button>
          <el-button type="text" size="small" class="danger-text" @click="deleteRow(scope.row)" v-auth="'/setting/umengpush/announcement/delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        :current-page="page"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadList"
      />
    </div>
  </div>
</template>

<script>
import UmengpushApi from '@/api/umengpush'
import Uediter from '@/components/UE.vue'

export default {
  name: 'UmengAnnouncement',
  components: { Uediter },
  data() {
    return {
      ueShow: true,
      ueConfig: {
        initialFrameWidth: 640,
        initialFrameHeight: 360,
        autoFloatEnabled: false,
      },
      publishing: false,
      loading: false,
      form: {
        title: '',
        content: '',
        push_summary: '',
        push_scope: 'none',
        target_user_id: '',
        sort: 0,
        is_home: 1,
        status: 1,
      },
      editingId: 0,
      tableData: [],
      page: 1,
      pageSize: 15,
      total: 0,
    }
  },
  created() {
    this.loadList(1)
  },
  methods: {
    onContentChange(html) {
      this.form.content = html
    },
    pushScopeText(scope) {
      return { none: '不推送', all: '全部用户', user: '指定用户' }[scope] || scope
    },
    statusText(status) {
      return { 0: '草稿', 1: '已发布', 2: '已下线' }[Number(status)] || '未知'
    },
    resetEditor() {
      this.ueShow = false
      this.form.content = ''
      this.$nextTick(() => {
        this.ueShow = true
      })
    },
    editRow(row) {
      this.editingId = Number(row.announcement_id)
      this.form.title = row.title || ''
      this.form.content = row.content || row.content_html || ''
      this.form.push_summary = row.push_summary || ''
      this.form.push_scope = 'none'
      this.form.target_user_id = ''
      this.form.sort = Number(row.sort) || 0
      this.form.is_home = Number(row.is_home) === 0 ? 0 : 1
      this.form.status = Number(row.status) === 2 ? 2 : 1
      this.ueShow = false
      this.$nextTick(() => { this.ueShow = true })
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    cancelEdit() {
      this.editingId = 0
      this.form.title = ''
      this.form.content = ''
      this.form.push_summary = ''
      this.form.sort = 0
      this.form.is_home = 1
      this.form.status = 1
      this.resetEditor()
    },
    submitEdit() {
      const title = (this.form.title || '').trim()
      const content = (this.form.content || '').trim()
      if (!this.editingId || !title || !content || content === '<p><br></p>') {
        this.$message.warning('请填写标题和正文')
        return
      }
      this.publishing = true
      UmengpushApi.announcementEdit({
        announcement_id: this.editingId,
        title,
        content,
        push_summary: (this.form.push_summary || '').trim(),
        sort: Number(this.form.sort) || 0,
        is_home: Number(this.form.is_home) === 1 ? 1 : 0,
        status: Number(this.form.status) === 2 ? 2 : 1,
      }).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          this.cancelEdit()
          this.loadList(1)
        }
      }).finally(() => { this.publishing = false })
    },
    deleteRow(row) {
      this.$confirm('删除后将从首页和动态列表下线，是否继续？', '提示', { type: 'warning' }).then(() => {
        return UmengpushApi.announcementDelete({ announcement_id: row.announcement_id })
      }).then(res => {
        if (res.code === 1) {
          this.$message.success('删除成功')
          this.loadList(this.page)
        }
      }).catch(() => {})
    },
    loadList(page) {
      if (page) this.page = page
      this.loading = true
      UmengpushApi.announcementList({ page: this.page, list_rows: this.pageSize })
        .then(res => {
          const list = (res.data && res.data.list) || {}
          this.tableData = list.data || []
          this.total = list.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitPublish() {
      const title = (this.form.title || '').trim()
      const content = (this.form.content || '').trim()
      if (!title || !content || content === '<p><br></p>') {
        this.$message.warning('请填写标题和正文')
        return
      }
      if (this.form.push_scope === 'user' && !Number(this.form.target_user_id)) {
        this.$message.warning('请填写目标用户 ID')
        return
      }
      this.publishing = true
      UmengpushApi.announcementPublish({
        title,
        content,
        push_summary: (this.form.push_summary || '').trim(),
        push_scope: this.form.push_scope,
        target_user_id: Number(this.form.target_user_id) || 0,
        sort: Number(this.form.sort) || 0,
        is_home: Number(this.form.is_home) === 1 ? 1 : 0,
      })
        .then(res => {
          if (res.code === 1) {
            const count = (res.data && res.data.push_message_count) || 0
            let msg = '公告发布成功'
            if (this.form.push_scope !== 'none') {
              msg += `，触达 ${count} 人`
            }
            this.$message.success(msg)
            this.form.title = ''
            this.form.push_summary = ''
            this.form.target_user_id = ''
            this.form.sort = 0
            this.form.is_home = 1
            this.resetEditor()
            this.loadList(1)
          }
        })
        .finally(() => {
          this.publishing = false
        })
    },
  },
}
</script>

<style scoped>
.publish-form {
  max-width: 800px;
  margin-bottom: 24px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
}
.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
}
.inline-tip {
  display: inline-block;
  margin-left: 10px;
}
.danger-text {
  color: #f56c6c;
}
.max-w640 {
  max-width: 640px;
}
.common-form {
  margin: 16px 0 12px;
  font-weight: bold;
  color: #303133;
}
.pagination {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/umengpush/announcement/index.vue